import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between mb-8">
      {steps?.map((step, index) => (
        <React.Fragment key={step?.id}>
          <div className="flex flex-col items-center gap-2 flex-1">
            <div
              className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center border-2 transition-all ${
                currentStep > index
                  ? 'bg-primary border-primary text-white'
                  : currentStep === index
                  ? 'border-primary text-primary bg-primary/10' :'border-border text-muted-foreground bg-card'
              }`}
            >
              {currentStep > index ? (
                <Icon name="Check" size={20} />
              ) : (
                <span className="font-semibold text-sm">{index + 1}</span>
              )}
            </div>
            <div
              className={`text-xs md:text-sm font-medium text-center ${
                currentStep >= index ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {step?.label}
            </div>
          </div>
          {index < steps?.length - 1 && (
            <div
              className={`h-0.5 flex-1 mx-2 transition-all ${
                currentStep > index ? 'bg-primary' : 'bg-border'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressIndicator;